import React from 'react';

import { useLocalization } from 'redux/localization/utils/hooks';

import Totals from './components/common/Totals';
import Next from './components/widget/Next';
import Pages from './components/widget/Pages';
import Previous from './components/widget/Previous';

// 50 is the C7 api default limit
const pageSize = 50;

const WidgetPagination = (props) => {
  const { page, recordCount, onChange } = props;

  const { t } = useLocalization();

  if (recordCount <= pageSize) {
    return null;
  }

  const totalPages = Math.ceil(recordCount / pageSize);

  return (
    <div className="c7-pagination">
      <nav
        className="c7-pagination__pages"
        aria-label={t('general.accessibility.pagination')}
      >
        <ul>
          <Previous currentPage={page} onChange={onChange} />
          <Pages
            currentPage={page}
            onChange={onChange}
            totalPages={totalPages}
          />
          <Next
            currentPage={page}
            onChange={onChange}
            totalPages={totalPages}
          />
        </ul>
      </nav>
      <Totals
        currentPage={page}
        pageSize={pageSize}
        recordCount={recordCount}
      />
    </div>
  );
};

export default WidgetPagination;
